import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../context/useAuth';
import { isNativePlatform } from '../native';

/** Shown on every page while a member's payment has failed or their dues have lapsed. */
export default function LapsedMembershipBanner() {
  const { user } = useAuth();
  if (user?.payment_grace_until && !user.payment_lapsed) {
    // Stripe is still retrying a past-due card; a canceled membership restarts at checkout.
    const retrying = user.payment_status === 'past_due';
    return (
      <div className="mb-4 flex flex-col gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 sm:flex-row sm:items-center">
        <AlertTriangle className="hidden shrink-0 text-amber-600 sm:block" size={18} />
        <p className="flex-1 text-sm text-amber-900">
          <span className="font-semibold">Your last membership payment didn’t go through.</span>{' '}
          {`${retrying ? 'Update your card' : 'Restart your membership'} by ${user.payment_grace_until} to keep full access.`}
          {isNativePlatform && ' Check your email for a link, or ask your facilitator.'}
        </p>
        {!isNativePlatform && (
          <Link
            to={retrying ? '/settings?tab=billing' : '/payment'}
            className="inline-flex justify-center rounded-lg bg-gold px-3 py-1.5 text-sm font-semibold text-white hover:bg-gold-dark transition whitespace-nowrap"
          >
            {retrying ? 'Update card' : 'Restart membership'}
          </Link>
        )}
      </div>
    );
  }
  if (!user?.payment_lapsed) return null;
  return (
    <div className="mb-4 flex flex-col gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 sm:flex-row sm:items-center">
      <AlertTriangle className="hidden shrink-0 text-amber-600 sm:block" size={18} />
      <p className="flex-1 text-sm text-amber-900">
        <span className="font-semibold">Your access is limited.</span>{' '}
        {isNativePlatform
          ? 'Your membership payment didn’t go through. Your facilitator can help you restart it.'
          : 'Your membership payment didn’t go through. Restart your membership to get full access back.'}
      </p>
      {!isNativePlatform && (
        <Link
          to="/payment"
          className="inline-flex justify-center rounded-lg bg-gold px-3 py-1.5 text-sm font-semibold text-white hover:bg-gold-dark transition whitespace-nowrap"
        >
          Restart membership
        </Link>
      )}
    </div>
  );
}
